import { ErrorBoundary } from 'react-error-boundary';
import { CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { DebugErrorProvider } from '@contexts/DebugErrorContext';
import { ModalProvider } from '@organisms/Modals/ModalContext';
import ToastsProvider from '@organisms/Toasts/ToastsProvider';
import { store } from '@store/store';
import ThemeWrapper from '@templates/ThemeWrapper';
import WorktreeBorderWrapper from '@templates/WorktreeBorderWrapper';
import RootRoutes from './routing/RootRoutes';
import ErrorFallback from '@templates/ErrorFallback';
import NuqsProvider from '@utils/nuqs/NuqsProvider';
import TelemetryInitializer from '@utils/TelemetryInitializer';

// ShowMe interactive help system
import { ShowMeProvider } from '@/features/showme/ShowMeProvider';
import { TourOverlay } from '@/features/showme/TourOverlay';
// Register scenarios
import '@/features/showme/scenarios/createElection';

// Initialize i18n - must be imported before any component that uses translations
import '@i18n/config';

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Provider store={store}>
        <TelemetryInitializer />
        <ThemeWrapper>
          <WorktreeBorderWrapper>
            <ToastsProvider>
              <CssBaseline />
              <BrowserRouter>
                <NuqsProvider>
                  <ShowMeProvider>
                    <ModalProvider>
                      <DebugErrorProvider>
                        <RootRoutes />
                      </DebugErrorProvider>
                    </ModalProvider>
                    <TourOverlay />
                  </ShowMeProvider>
                </NuqsProvider>
              </BrowserRouter>
            </ToastsProvider>
          </WorktreeBorderWrapper>
        </ThemeWrapper>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
